import { Component } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { AppLoadingService } from './app-loading.service';
import {Observable} from 'rxjs/index';


@Component({
  selector: 'app-loading-panel',
  templateUrl: './app-loading-panel.component.html',
  styleUrls: ['./app-loading-panel.component.scss'],
  animations: [
      trigger(
        'showHidePanel', [
          transition(':enter', [
            style({opacity: 0}),
            animate('250ms', style({opacity: 1}))
          ]),
          transition(':leave', [
            style({ opacity: 1}),
            animate('250ms', style({ opacity: 0}))
          ])
        ]
      )
    ]
})
export class AppLoadingPanelComponent {
  isLoading$: Observable<boolean>;
  constructor(private appLoading: AppLoadingService) {
    this.isLoading$ = this.appLoading.isLoading$;
  }
}
